(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallStatus', PhoneCallStatus);

    PhoneCallStatus.$inject = ['$resource'];

    function PhoneCallStatus ($resource) {
        var resourceUrl =  'api/phone-call-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
